// @ts-nocheck
import axios from 'axios';
import { BASE_URL } from '../../../../queries/useDataEngine';

export const UserManagementService = {
  createGroup: (payload) => axios.post(`${BASE_URL}/auth/creategroup`, payload),

  deleteGroup: (params) =>
    axios.delete(`${BASE_URL}/auth/deletegroup`, { params }),

  getGroups: (params = {}, loader = true) =>
    axios.get(`${BASE_URL}/auth/readgroup`, { params, loader }),

  updateGroup: (payload) => axios.put(`${BASE_URL}/auth/updategroup`, payload),

  getGroupTasks: (params = {}, loader = true) =>
    axios.get(`${BASE_URL}/auth/getGroupTask`, { params, loader }),

  assignTask: (payload) => {
    const isLoader = payload?.loader ?? true;
    const { loader: _, ...cleanPayload } = payload || {};
    return axios.post(`${BASE_URL}/auth/assignTask`, cleanPayload, {
      loader: isLoader,
    });
  },

  getAllUsers: (params = {}, loader = true) =>
    axios.get(`${BASE_URL}/auth/getAlluser`, { params, loader }),
};
